import React  from 'react';

import './Cotizar.scss';
import FormHeader from '../FormHeader/FormHeader';
import Button from '../Button';
import { Link, useParams } from 'react-router-dom';
import Steps from '../Steps';
import { scrollToTop } from '../../utils/helpers';
import { useEffect } from 'react';


const Cotizar = ({ logoUrl, car, isLoading }) => {
  const { tipo, modelo, color, version, anio } = useParams();

  useEffect(() => {
    scrollToTop(0);
  }, []);
  const baseUrl = `/${tipo}/${modelo}/${version}/${anio}/${color}`;
  const steps = [
    {
      id: 1,
      image: require('../../images/test-drive.svg'),
      title: "TEST DRIVE",
      button: <Button component={Link} to={`${baseUrl}/test-drive`} type='red'>Ir</Button>,
      desc: 'Agendá una cita para que podas probar tu vehículo'
    },
    {
      id: 2,
      image: require('../../images/tour-virtual2.svg'),
      title: "TOUR VIRTUAL",
      button: <Button component={'a'} target="_blank" href={'/?marca=Mitsubishi#tour-virtual__frame'} type='red'>Ir</Button>,
      desc: 'Conocé tu vehículo reservado en nuestro Tour virtual'
    },
    {
      id: 3,
      image: require('../../images/cotiza.svg'),
      title: "AVALÚO VIRTUAL",
      button: <Button component={Link} to={'/avaluo'} type='red'>Ir</Button>,
      desc: 'Realizá el avalúo del vehículo que pensás entregar de manera virtual'
    },
    {
      id: 4,
      image: require('../../images/estrenar2.svg'),
      title: "Estrenar",
      desc: '¡Recordá traer tu cédula!'
    }
  ]

  return (
    <div className="purchase gradient gradient--full" style={{ '--color': car?.colorCode }}>
      <FormHeader
        isLoading={isLoading}
        car={car}
        logoUrl={logoUrl}
        headerText="ENVÍO DE COTIZACIÓN POR CORREO"
        headerSubText="Probá tu próximo chuzo…"
        bottomBorder
      />
      <div className="purchase__content confirm-content">
        <h3>ESTAS A UN PASO MÁS CERCA</h3>
        <p>Hemos enviado la información de este chuzo a tu correo electrónico. Recordá que también podes hacer un test drive de este vehículo, o si ya te decidiste podes reservarlo.</p>
        <h4>NO TE QUEDES SIN EL TUYO.</h4>
        <div>
          <Button component={Link} to={`${baseUrl}/resumen/`} type="red">
            Volver al Resumen
          </Button>
        </div>
        <div>
          <Button component={Link} to={`${baseUrl}/reservar/`} type="red">
            Comprar/Reservar
          </Button>
        </div>
        
        <Steps steps={steps} />
      </div>
    </div>
  );
};

export default Cotizar;
